import React from 'react';
import { View } from 'react-native';
import { ExpenseFormInput } from '../ExpenseWidget/ExpenseFormItem';
import { widgetStyles } from '../../styles/theme';

const DescriptionWidget = ({ style, description, onUpdate }) => {
  return (
    <View style={style}>
      <View style={widgetStyles.widget}>
        <ExpenseFormInput
          height={200}
          label="Event Description"
          multiline
          value={description}
          onChangeText={(value) => onUpdate(value)}
          icon={!description && 'message'}
        />
      </View>
    </View>
  );
};

export default DescriptionWidget;
